/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customFieldIndexDataSchema = z.object({
	fields: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			type: z.literal('text'),
			location: z.literal('invoice'),
			isRequired: z.boolean(),
		}),
	),
})

export type CustomFieldIndexDataSchema = z.infer<typeof customFieldIndexDataSchema>
